import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "@inertiajs/react";

export default function SuccessPanel() {
  return (
    <section className="card mx-auto max-w-2xl">
      <div className="card-body text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 text-primary">
          <CheckCircleIcon className="h-8 w-8" aria-hidden="true" />
        </div>
        <h1 className="mb-2 text-2xl font-semibold">Setting up your subscription...</h1>
        <p className="mx-auto mb-6 max-w-lg text-gray-600">
          Stripe is confirming your payment. Your subscription page will show the updated credits once processing
          finishes.
        </p>
        <Link href="/subscription" className="btn btn-primary inline-flex">
          View Subscription
        </Link>
      </div>
    </section>
  );
}
